/**
 * In ms, the difference from mousedown to mouseup on the card
 * below which we consider it a click. Any more than this and we assume
 * the user is selecting text or dragging content somewhere.
 */
const CLICK_DELTA = 200;

/**
 * @module publica-link-card
 * @description
 * A custom element that renders a base card wrapper and handles the
 * functionality of making the whole card clickable. Just provide a
 * child link with `[slot="link"]`.
 */
export class LinkCard extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.attachShadow({ mode: "open" });

		const template = document.createElement("template");

		template.innerHTML = `
			<article part="base">
				<style>
					:host {
						display: block;
					}
				</style>
				<slot></slot>
			</article>
		`
			.replaceAll(/\s\s+/g, " ")
			.trim();

		this.shadowRoot?.append(template.content.cloneNode(true));

		const base = this.shadowRoot?.querySelector("[part='base']");
		const link: HTMLAnchorElement | null = this.querySelector("a[slot='link']");

		this.bindLinkClick(base, link);
	}

	bindLinkClick(
		base: Element | null | undefined,
		link: HTMLAnchorElement | null,
	) {
		if (base == null || link == null) return;

		/** Mouse down timestamp */
		let down: number;
		/** Mouse up timestamp */
		let up: number;

		if (base instanceof HTMLElement) {
			base.style.cursor = "pointer";
		}

		base.addEventListener("mousedown", () => {
			down = Date.now();
		});

		base.addEventListener("mouseup", () => {
			up = Date.now();

			// Allow text selection without registering a click
			if (up - down < CLICK_DELTA) {
				link.click();
			}
		});
	}
}
